import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { ApiCMSRequest } from "data/ApiCMS";
import { Handler } from "../types";

type EventClassificationsResponse = {
  EventClassifications: { items: Array<{ id: number; title: string }> };
};

type EventClassificationResponse = {
  EventClassification: { id: number; title: string };
};

const EventClassificationHandler: Handler<EventClassificationsResponse, EventClassificationResponse> = {
  query: print(gql`
    query EventClassifications($search: String) {
      EventClassifications(search: $search, perPage: 100) {
        items { id title }
      }
    }
  `),
  formater: (data) =>
    data.EventClassifications.items.map((item) => ({ id: item.id, label: item.title })),
  api: ApiCMSRequest,
  queryId: print(gql`
    query EventClassification($id: Int!) {
      EventClassification(id: $id) { id title }
    }
  `),
  formaterId: (data) => ({
    id: data.EventClassification.id,
    label: data.EventClassification.title,
  }),
};

export default EventClassificationHandler;
